import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'appendDomain',
  standalone: true,
})
export class AppendDomainPipe implements PipeTransform {
  private readonly devDomain = 'https://dev.ccomx.app/';
  private readonly localDomain = 'http://localhost:5000/';

  transform(link?: string): string {
    if (!link || link.indexOf('http') !== -1 || link.startsWith('data:image')) {
      return link || '';
    }

    if (this.isLocalhost()) {
      if (this.isRemoteDev()) {
        return this.prependDomain(this.devDomain, link);
      }
      if (this.isLocalDev()) {
        return this.prependDomain(this.localDomain, link);
      }
      return this.prependDomain(this.getBaseUrlFromApi(), link);
    }

    return link;
  }

  private isLocalhost(): boolean {
    return window.location.hostname === 'localhost';
  }

  private isRemoteDev(): boolean {
    return environment.environmentName === 'remote-development';
  }

  private isLocalDev(): boolean {
    return environment.environmentName === 'localdev';
  }

  private getBaseUrlFromApi(): string {
    const apiUrl = environment.apiUrl || '';
    const base = apiUrl.replace(/\/api\/?$/, '');
    return base ? `${base.endsWith('/') ? base : base + '/'}` : this.localDomain;
  }

  private prependDomain(domain: string, link: string): string {
    return `${domain}${link}`;
  }
}
